import axios from "axios";
import React, {useEffect, useRef, useState} from "react";
import {Link, useParams} from 'react-router-dom';
import Swal from 'sweetalert2';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {baseUrl, formatDateTime, ipAddress, userLocation, userName} from '../Univ.js'
function DischargeNotes() {
    const {ip_id} = useParams();
    const [temp, setTemp] = useState([]);
    const [ipData, setIpData] = useState([]);
    const [selectedTemplate, setselectedTemplate] = useState('');
    const quillRef = useRef(null);
    const [templateData, setTemplateData] = useState({template: ''});
    const [disData, setdisData] = useState([]);
    const [notesData, setNotesData] = useState({
        "ip": '', "dis_notes": '', "status": '', "addedby": '', "ip_add": ''
    });
    useEffect(() => {
        fetchtempData();
        fetchipData();
    }, [ip_id]);
    function fetchtempData() {
        axios.get(`${baseUrl}template-create/`)
            .then(response => {
                setTemp(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    useEffect(() => {
        if (selectedTemplate) {
            fetchTcData(selectedTemplate);
        }
    }, [selectedTemplate]);
    const handleTemplateChange = (event) => {
        const selectedTemplateId = event.target.value;
        setselectedTemplate(selectedTemplateId);
    };
    function fetchTcData(selectedTemplateId) {
        axios.get(baseUrl + "edit-template/" + selectedTemplateId + "/")
            .then(response => {
                setTemplateData(response.data);
                setNotesData(prevNotesData => ({
                    ...prevNotesData, dis_notes: response.data.template
                }));
            })
            .catch(error => {
                console.log(error);
            });
    }
    function fetchipData() {
        axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
            .then(response => {
                setIpData([response.data]);
            })
            .catch(error => {
                console.log(error);
            });
    }
    useEffect(() => {
        fetchdisData();
    }, []);
    function fetchdisData() {
        axios.get(baseUrl + "view-discharge/" + ip_id + "/")
            .then(response => {
                setdisData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const inputHandler = (eventOrValue) => {
        const value = eventOrValue.target ? eventOrValue.target.value : eventOrValue;
        setNotesData({
            ...notesData, dis_notes: value,
        });
    };
    const formSubmit = (e) => {
        e.preventDefault();
        const dis_notes = document.getElementById("dis_notes").value;
        const _formData = new FormData();
        _formData.append('ip', ip_id);
        _formData.append('dis_notes', notesData.dis_notes);
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        try {
            axios.post(baseUrl + 'discharge-notes-create/', _formData, {
                headers: {
                    'content-type': 'multiple/form-data'
                }
            })
                .then(function (response) {
                    if (response.status == 200 || response.status == 201) {
                        Swal.fire({
                            title: 'Data has been updated', icon: 'success', timer: 2000, showConfirmButton: false
                        });
                        setTimeout(() => {
                            window.location.href = ('/discharge-notes/' + ip_id + '/');
                        }, 2000);
                    }
                });
        } catch (error) {
            console.log(error);
        }
    };
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-discharge/' + id + '/')
                        .then(function (response) {
                            Swal.fire('success', 'Data has been Deleted');
                        });
                    setTimeout(() => {
                        window.location.href = ('/discharge-notes/' + ip_id + '/');
                    }, 2000);
                } catch (error) {
                    Swal.fire('error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('error', 'Data has not been deleted');
            }
        })
    }
    const handleLoad = (quill) => {
        quillRef.current = quill;
    };
    return (<section className="container mt-4">
        <div className="row">
            <div className="table-responsive">
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                        <th>Patient</th>
                        <th>IP ID</th>
                        <th>Patient ID</th>
                        <th>Patient Name</th>
                        <th>Gender</th>
                        <th>D.O.B/Age</th>
                        <th>Mobile</th>
                        <th>Regd. On</th>
                    </tr>
                    </thead>

                    <tbody>
                    {ipData.map((patientData, index) => (<tr>
                        <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail"
                                 style={{width: 120, height: 60}}/></td>
                        <td>{patientData.ip_id}</td>
                        <td>{patientData.pat.pat_id}</td>
                        <td>{patientData.pat.patient}</td>
                        <td>{patientData.pat.gender}</td>
                        <td>{patientData.pat.age}</td>
                        <td>{patientData.pat.mobile}</td>
                        <td>{formatDateTime(patientData.admit_date)}</td>
                    </tr>))}
                    </tbody>
                </table>
            </div>
            <div className='col-md-9 col-12 mb-2'>
                <div className='card'>
                    <h4 className='card-header'>Discharge Notes</h4>
                    <div className='card-body'>
                        <form>
                            <div className="mb-3">
                                <label htmlFor="type" className="form-label">Select Template</label>
                                <select name="selectedTemplate" value={selectedTemplate}
                                        onChange={handleTemplateChange} className="form-control">
                                    <option>Select Template</option>
                                    {temp.map((template, index) => (<option key={index} value={template.id}>
                                        {template.type}
                                    </option>))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="type" className="form-label">Template</label>
                                <ReactQuill
                                    style={{height: "200px", marginBottom: "80px"}}
                                    className="my-quill"
                                    tabIndex="0"
                                    onLoad={handleLoad}
                                    name="dis_notes"
                                    id="dis_notes"
                                    value={templateData.template}
                                    onChange={(value) => {
                                        setTemplateData({template: value});
                                        setNotesData(prevNotesData => ({
                                            ...prevNotesData, dis_notes: value
                                        }));
                                    }}

                                    modules={{
                                        toolbar: [[{header: [1, 2, false]}], ['bold', 'italic', 'underline', 'strike', 'blockquote'], [{list: 'ordered'}, {list: 'bullet'}, {indent: '-1'}, {indent: '+1'},], ['link', 'image'], ['table'], ['clean'],],
                                    }}
                                />

                            </div>

                            <button type="button" onClick={formSubmit} className="btn btn-primary mt-5">Submit
                            </button>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div className="card card-body">
            <div className="table-responsive">
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                        <th>Date</th>
                        <th>DischargeNotes</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                    </thead>
                    <tbody>
                    {disData.map((dis, index) => (<tr>
                        <td>{dis.add_date}</td>
                        <td dangerouslySetInnerHTML={{__html: dis.dis_notes}}></td>

                        <td><Link to={`/edit-discharge/${dis.id}/`} target="_blank"
                                  className="btn btn-warning">Edit</Link></td>
                        <td>
                            <button className="btn btn-danger" type="button"
                                    onClick={() => handleDelete(dis.id)}>
                                Delete
                            </button>
                        </td>

                    </tr>))}
                    </tbody>
                </table>
            </div>
        </div>
    </section>)
}
export default DischargeNotes;